import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import { Trackload } from "./pages/Truckload";
import { Trackloads } from "./pages/Truckloads";
import MainChat from "./modules/Chat/Component/Main/Main";
import { LiveTrackingPage } from "./pages/livetracking/live-tracking";
import MyTruckersList from "./pages/MyTruckers";
import withTracker from "./withTracker";
import InvoicesList from "./pages/Invoices";

const ECommercePage = lazy(() =>
  import("./modules/ECommerce/pages/eCommercePage")
);
const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);
const Search = lazy(() => import("./modules/Search/Search"));
const ImportTruckerPage = lazy(() => import("./pages/ImportTrucker"));
const ImportLoadsPage = lazy(() => import("./pages/ImportLoads"));
export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute
          path="/dashboard"
          component={withTracker(DashboardPage)}
        />
        <ContentRoute path="/trackloads" component={withTracker(Trackloads)} />
        <Route path="/shipper" component={withTracker(ECommercePage)} />
        <Route path="/user-profile" component={withTracker(UserProfilepage)} />
        <Route path="/search/:id/" component={withTracker(Search)} />
        <Route path="/ImportLoads" component={withTracker(ImportLoadsPage)} />
        <Route
          path="/ImportTrucker"
          component={withTracker(ImportTruckerPage)}
        />
        <Route path="/Truckers" component={withTracker(MyTruckersList)} />
        <Route path="/Invoices" component={withTracker(InvoicesList)} />
        <Route path="/Messages" component={withTracker(MainChat)} />
        {/* <Route path="/chat" component={Chat} /> */}
        <Route path="/trackload/:id/details" component={Trackload} />
        <Route
          path="/livetracking/:id"
          component={withTracker(LiveTrackingPage)}
        />

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
